import { Observable } from 'rxjs';

export abstract class ActionDefinition<T> {
  public abstract invoke(context: T): void | Observable<any>;
}
